/*
 * Copyright © 2023 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

// Utility function to get the enum key by value and return string representation of the key
export function getEnumKeyByValue<T extends string>(myEnum: Record<string, T>, enumValue: T): keyof typeof myEnum {
  const keys = Object.keys(myEnum).filter((key) => myEnum[key] === enumValue)
  return keys.length > 0 ? keys[0] : ""
}
